module.exports = __webpack_public_path__ + "static/media/nyquiz.12781fab.svg";